import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const FootballIcon = observer('FootballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M12 2C17.5227 2 22 6.47711 22 12C22 17.5227 17.5227 22 12 22C6.47711 22 2 17.5227 2 12C2 6.47711 6.47711 2 12 2ZM12 5.45801L8.97559 3.87305C7.4877 4.43212 6.18133 5.38872 5.19824 6.6377L5.77734 9.98242L3.33301 12.3516C3.39819 13.9473 3.90626 15.4936 4.7998 16.8174L8.15137 17.3047L9.64844 20.3398C11.1855 20.7754 12.8145 20.7754 14.3516 20.3398L15.8486 17.3047L19.209 16.8174C20.0992 15.4927 20.6043 13.9464 20.667 12.3516L18.2227 9.98242L18.791 6.6377C17.8079 5.38858 16.5009 4.43216 15.0127 3.87305L12 5.45801ZM15.8047 10.7715L14.3506 15.2422H9.64844L8.19531 10.7715L12 8.00684L15.8047 10.7715Z'
                fill='fill'
            />
        </SvgElement>
    );
});
